import React from 'react';
import Modal from './Modal';
import './PrivacyModal.css';

function PrivacyModal({ isOpen, onClose }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="privacy-modal">
        <h2>Privacy Policy</h2>

        <div className="privacy-content">
          <p className="privacy-updated">Last Updated: October 7, 2025</p>

          <section>
            <h3>Information We Collect</h3>
            <p>
              Wordle 6 7 is designed to respect your privacy. We collect minimal information necessary to provide the game experience:
            </p>
            <ul>
              <li><strong>Game Data:</strong> Your game progress, guesses, and statistics are stored locally in your browser's localStorage. This data never leaves your device.</li>
              <li><strong>Timezone Information:</strong> We detect your timezone to provide the correct daily puzzle. This is stored locally and sent to our servers only to retrieve the appropriate puzzle.</li>
              <li><strong>Analytics:</strong> We may use Google Analytics or similar services to understand how players use the game (aggregated, anonymous data only).</li>
            </ul>
          </section>

          <section>
            <h3>Advertising</h3>
            <p>
              This site displays ads through Google AdSense. Google may use cookies and other tracking technologies to serve personalized ads based on your browsing activity.
            </p>
            <p>
              For more information about how Google uses data when you use our site, visit: <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noopener noreferrer">Google's Privacy &amp; Terms</a>
            </p>
            <p>
              You can opt out of personalized advertising by visiting: <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer">Google Ad Settings</a>
            </p>
          </section>

          <section>
            <h3>Cookies</h3>
            <p>
              We use localStorage (a browser storage mechanism similar to cookies) to save your game progress and preferences. Third-party services like Google AdSense may set their own cookies for advertising purposes.
            </p>
          </section>

          <section>
            <h3>Data Storage</h3>
            <p>
              All game data is stored locally on your device. If you clear your browser data or localStorage, your game progress will be lost. We do not store your game data on our servers.
            </p>
          </section>

          <section>
            <h3>Third-Party Services</h3>
            <p>We use the following third-party services:</p>
            <ul>
              <li><strong>Google AdSense:</strong> For displaying advertisements</li>
              <li><strong>Netlify:</strong> For hosting the website</li>
              <li><strong>Render:</strong> For hosting our API</li>
            </ul>
            <p>These services have their own privacy policies governing their use of your information.</p>
          </section>

          <section>
            <h3>Your Rights</h3>
            <p>
              Since we don't collect or store personal information on our servers, there is no account data to access, modify, or delete. You can clear your local game data at any time by clearing your browser's localStorage or using your browser's privacy settings.
            </p>
          </section>

          <section>
            <h3>Children's Privacy</h3>
            <p>
              Our service is available to users of all ages. We do not knowingly collect personal information from anyone.
            </p>
          </section>

          <section>
            <h3>Changes to This Policy</h3>
            <p>
              We may update this privacy policy from time to time. Changes will be posted on this page with an updated revision date.
            </p>
          </section>

          <section>
            <h3>Contact</h3>
            <p>
              If you have questions about this privacy policy, please contact us through our website.
            </p>
          </section>
        </div>

        <button className="privacy-close-btn" onClick={onClose}>
          Close
        </button>
      </div>
    </Modal>
  );
}

export default PrivacyModal;
